export function getReviewId(selectedId: string | undefined, reviews: any[] = []): string {
	const safeSelectedId = selectedId || 'initial';
	const isInitialVersion = safeSelectedId === 'initial';
	const isGeneralVersion = safeSelectedId === 'general';

	if (isInitialVersion) return reviews?.[0]?.id || '';
	if (isGeneralVersion) return reviews?.[reviews.length - 1]?.id || reviews?.[0]?.id || '';

	return safeSelectedId;
}
